import React from 'react'
import './VideoList.css'
import { Link } from 'react-router-dom';
import { useState, useEffect } from "react";
import { FaAngleUp } from "react-icons/fa";


export default function VideoList() {
    const [showTopBtn, setShowTopBtn] = useState(false);
    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        });
    }, []);

    const goToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <div className='container_videoslist'>

            {/* Стрелка вверх */}
            <div className="top-to-btm">
                {" "}
                {showTopBtn && (
                    <FaAngleUp
                        className="icon-position icon-style"
                        onClick={goToTop}
                    />
                )}{" "}
            </div>


            {/* выставляет все блоки по центру */}
            <div className='container_dysplay_videoslist'>

                {/* Кнопка */}
                <div className='button__text_videoslist margin_button__text_videoslist'>
                    <Link component={Link} to="/Videos" className="glow-on-hover_videoslist">Шаг назад</Link>
                </div>

                {/* Кнопка */}
                <div className='button__text_videoslist'>
                    <a href="https://tele.click/{Freelance3359}" className="glow-on-hover_videoslist">Телеграмм</a>
                </div>

                {/* Текст */}
                <div className='text_block_center_videoslist'>
                    <p className='text_block__videoslist'>Все свои проекты по видео монтажу, я размещаю сюда, если вы будете против этого то я уберу его из данного списка.</p>
                </div>

                {/* Стрелка */}
                <div className='imageblock_videoslist'>
                    <a href="#videoList_one" className="arrow-container">
                        <div className="arrow"></div>
                        <div className="arrow"></div>
                        <div className="arrow"></div>
                    </a>
                </div>

                {/* Текст */}
                <div className='portfolio_videoList' id='videoList_one'>
                    <h2 className='portfolio_text_videoslist'>Видео меньше 1 минуты</h2>
                </div>

                {/* Стрелка */}
                <div className='imageblock_videoslist'>
                    <a href="#videoList_two" className="arrow-container">
                        <div className="arrow"></div>
                        <div className="arrow"></div>
                        <div className="arrow"></div>
                    </a>
                </div>

                {/* Видео */}
                <div className='videoBlock_center_videoslist'>
                    <iframe className='videoBlock_videoslist' src="https://drive.google.com/file/d/1gHs97zYzsLKOxlzJQjC_hYBPYf0Gswzv/preview" ></iframe>
                    <iframe className='videoBlock_videoslist margin_videoBlock_videoslist' src="https://drive.google.com/file/d/1dGPTY-_1wgZBOekG6bJzTNTsWfUg-KSp/preview"></iframe>
                    <iframe className='videoBlock_videoslist margin_videoBlock_videoslist' src="https://drive.google.com/file/d/1wfGTu2XBAS6qHNFlWJTIBUkHJJIa_181/preview"></iframe>
                    <iframe className='videoBlock_videoslist margin_videoBlock_videoslist' src="https://drive.google.com/file/d/1Ie-TmSXm3OEhL55aGcgkRJCvFcEDnu5i/preview"></iframe>
                    <iframe className='videoBlock_videoslist margin_videoBlock_videoslist' src="https://drive.google.com/file/d/124xiVIKP7UU9WLnYR5HsBr6dwQdWOkXG/preview"></iframe>
                    <iframe className='videoBlock_videoslist ' src="https://drive.google.com/file/d/1G2eiVFybOdLiH_srWSJOx9fXLqRAYV9v/preview" ></iframe>
                    <iframe className='videoBlock_videoslist margin_videoBlock_videoslist' src="https://drive.google.com/file/d/1PIBHGL-UU-EgwgS0BIwbg-_Xuz7ySijL/preview"></iframe>
                    <iframe className='videoBlock_videoslist margin_videoBlock_videoslist' src="https://drive.google.com/file/d/1nuwotZmeM_HiDALDUU72GXtiFNvF5GE-/preview"></iframe>
                    <iframe className='videoBlock_videoslist margin_videoBlock_videoslist' src="https://drive.google.com/file/d/1tFM_NogP_qGlkgo0sJE6kzsM7Fpxis5v/preview"></iframe>
                    <iframe className='videoBlock_videoslist margin_videoBlock_videoslist' src="https://drive.google.com/file/d/1KOy5Eyed4bji5-GO-T9XA6FUNQAMI24R/preview"></iframe>
                    <iframe className='videoBlock_videoslist' src="https://drive.google.com/file/d/1Al6wUYH2ViBXx_j939I1ydZapj6lR6WB/preview" ></iframe>
                    <iframe className='videoBlock_videoslist margin_videoBlock_videoslist' src="https://drive.google.com/file/d/11bEuhS8HHZWzFeg45FF_iNfkpv_DdauX/preview"></iframe>
                    <iframe className='videoBlock_videoslist margin_videoBlock_videoslist' src="https://drive.google.com/file/d/1KmSjmkWp4BjEubK2mzX_x6dbEeDS8J_r/preview"></iframe>
                    <iframe className='videoBlock_videoslist margin_videoBlock_videoslist' src="https://drive.google.com/file/d/1gHs97zYzsLKOxlzJQjC_hYBPYf0Gswzv/preview"></iframe>
                    <iframe className='videoBlock_videoslist margin_videoBlock_videoslist' src="https://drive.google.com/file/d/1YXBwO33DKDFhW7HY7rDa4Gvb-ILnlvYS/preview"></iframe>
                    <iframe className='videoBlock_videoslist' src="https://drive.google.com/file/d/17jF8UzSRwzXEmTkhxtW-_6x2fbvIzMWs/preview"></iframe>
                    <iframe className='videoBlock_videoslist margin_videoBlock_videoslist' src="https://drive.google.com/file/d/1XMWQrctVQBNC8QghSCvYcrDLQTXR-ocu/preview"></iframe>
                    <iframe className='videoBlock_videoslist margin_videoBlock_videoslist' src="https://drive.google.com/file/d/1kj_zyUGwnumwsjfsUMr5YQlL3gyK63Nm/preview"></iframe>
                    <iframe className='videoBlock_videoslist margin_videoBlock_videoslist' src="https://drive.google.com/file/d/1kHKrNrhZO5wc9GmPy6uDTWsjOp5nwOHm/preview"></iframe>
                    <iframe className='videoBlock_videoslist margin_videoBlock_videoslist' src="https://drive.google.com/file/d/1zRtphcGxcEixJFxPH1QQlZEOianb6TEg/preview"></iframe>
                </div>

                {/* Текст */}
                <div className='portfolio_videoList' id='videoList_two'>
                    <h2 className='portfolio_text_videoslist'>Видео больше 1 минуты</h2>
                </div>

                {/* Видео */}
                <div className='videoBlock_center_videoslist'>
                    <iframe className='videoBlock_videoslist ' src="https://drive.google.com/file/d/1Fpc0w52ezCD_YZ1DhNzpIC_VNUUPP8w4/preview" ></iframe>
                    <iframe className='videoBlock_videoslist margin_videoBlock_videoslist' src="https://drive.google.com/file/d/1hjwi6HeWpFx5QR3sIz21z4wyg4_MZwVo/preview"></iframe>
                    <iframe className='videoBlock_videoslist margin_videoBlock_videoslist' src="https://drive.google.com/file/d/1psBBFLr2qtJo8NN5Kwlc4QvF01F6rfS6/preview"></iframe>
                    <iframe className='videoBlock_videoslist margin_videoBlock_videoslist' src="https://drive.google.com/file/d/1jvxkNsNGl42IeCd8-kzcqTj-Ba6YrWPu/preview"></iframe>
                    <iframe className='videoBlock_videoslist margin_videoBlock_videoslist' src="https://drive.google.com/file/d/1AXRtS2VRRLTUYWxCCUR5NxNDaQ5HhqYd/preview"></iframe>
                </div>


            </div>
        </div >

    )
}
